import { z } from 'zod';
import type { Account } from './types';

export const accountEditFields = z.object({
  code: z.string().trim().min(1).max(40),
  name: z.string().trim().min(1).max(200),
  group: z.string().trim().min(1).max(100),
  nature: z.enum(['Asset', 'Liability', 'Equity', 'Income', 'Expense']),
  control: z.boolean(),
  active: z.boolean()
}).strict();
export type AccountEditFields = z.infer<typeof accountEditFields>;
export interface AccountDetails {
  account: Account;
  hasBalance?: boolean;
  openingPending?: boolean;
  structuralLocked: boolean;
  codeLocked: boolean;
  defaultFields: string[];
}
export const editableAccount = (account: Account): AccountEditFields => ({
  code: account.code, name: account.name, group: account.group,
  nature: account.nature, control: account.control, active: account.active
});
export const accountEditRequest = z.object({
  account: accountEditFields,
  expectedRevision: z.number().int().positive(),
  reason: z.string().trim().min(5).max(500)
}).strict();

